var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8125 4.375H11.875C11.2119 4.375 10.5763 4.63812 10.1075 5.1075C9.63813 5.57625 9.375 6.21188 9.375 6.875C9.375 12.7288 9.375 27.2712 9.375 33.125C9.375 33.7881 9.63813 34.4237 10.1075 34.8925C10.5763 35.3619 11.2119 35.625 11.875 35.625C13.8412 35.625 16.25 35.625 16.25 35.625",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 35.625H28.125C28.7881 35.625 29.4237 35.3619 29.8925 34.8925C30.3619 34.4237 30.625 33.7881 30.625 33.125C30.625 27.1637 30.625 12.1938 30.625 6.5625C30.625 5.35438 31.6044 4.375 32.8125 4.375C33.3925 4.375 33.9487 4.60562 34.3594 5.01562C34.7694 5.42625 35 5.9825 35 6.5625C35 9.16875 35 13.5131 35 16.25C35 17.6306 33.8806 18.75 32.5 18.75C31.5481 18.75 30.6875 18.75 30.6875 18.75",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 14.0625V20.625C15 20.9562 15.1319 21.2744 15.3663 21.5088C15.6006 21.7431 15.9188 21.875 16.25 21.875C18.1712 21.875 21.8288 21.875 23.75 21.875C24.0812 21.875 24.3994 21.7431 24.6338 21.5088C24.8681 21.2744 25 20.9562 25 20.625C25 18.4181 25 14.0625 25 14.0625",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 15.3769L20 10L26.875 15.3769",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 26.25H24.0625",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 29.375H24.0625",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 34.375L19.6875 36.25L23.125 32.5",
    stroke: "#1C2541",
    strokeWidth: 1.5,
    strokeMiterlimit: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService1);
export default __webpack_public_path__ + "static/media/service1.92cc1ce7d599d590de4bd233f8b36d0f.svg";
export { ForwardRef as ReactComponent };